import { Directive, ElementRef, Inject, OnInit } from '@angular/core';
import { componentStylesByTheme } from '../utils/theme.utils';
import { THEME_TOKEN, Theme } from '../types/theme.types';
import { switchStylesSAG, switchStylesSHS } from './switch.styles';
import { style } from '../utils/style.utils';

@Directive({
  selector: 'input[sag-ui-switch]',
})
export class SwitchDirective implements OnInit {
  constructor(
    @Inject(THEME_TOKEN) private readonly theme: Theme,
    private readonly elementRef: ElementRef<HTMLInputElement>
  ) {}

  ngOnInit(): void {
    const inputStyles = componentStylesByTheme(
      this.theme,
      switchStylesSAG,
      switchStylesSHS
    );
    style(this.elementRef, inputStyles());
  }
}
